import { render } from "./ProviderLogo.vue?vue&type=template&id=0bbe80ff&scoped=true"
import script from "./ProviderLogo.vue?vue&type=script&lang=js"
export * from "./ProviderLogo.vue?vue&type=script&lang=js"

import "./ProviderLogo.vue?vue&type=style&index=0&id=0bbe80ff&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0bbe80ff"

export default script